// policyActions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreatePolicyPayload, UpdatePolicyPayload, DeletePolicyPayload, FetchPolicyByIdPayload } from './policyTypes';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';

// Create Policy
export const createPolicy = createAsyncThunk(
  'policies/createPolicy',
  async (data: any, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('Name', data.Name);
      formData.append('Description', data.Description || '');
      formData.append('EffectiveDate', data.EffectiveDate);
      formData.append('SelectedType', data.SelectedType || ''); 
      formData.append('SelectedTypeId', String(data.SelectedTypeId)); 
      formData.append('CreatedBy', String(data.createdBy));
      formData.append('policyDocument', data.file);
      formData.append('Status', data.Status);
      formData.append('IsPublic' , data.IsPublic);
      formData.append('PrivateAccess' , data.PrivateAccess);

      const response = await employeeServiceApiInstance.post('/policies', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create policy');
    }
  }
);


// Update Policy
export const updatePolicy = createAsyncThunk(
  'policies/updatePolicy',
  async ({ policyId, ...data }: any & { policyId: number }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('Name', data.Name);
      formData.append('Description', data.Description || '');
      formData.append('EffectiveDate', data.EffectiveDate);
      formData.append('SelectedType', data.SelectedType || ''); 
      formData.append('SelectedTypeId', String(data.SelectedTypeId)); 
      formData.append('modifiedBy', String(data.modifiedBy));
      formData.append('policyDocument', data.file);
      formData.append('Status', data.Status);
      formData.append('IsPublic' , data.IsPublic);
      formData.append('PrivateAccess' , data.PrivateAccess);

      const response = await employeeServiceApiInstance.put(`/policies/${policyId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update policy');
    }
  }
);

// Delete Policy
export const deletePolicy = createAsyncThunk(
  'policies/deletePolicy',
  async ({ policyId }: DeletePolicyPayload, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/policies/${policyId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete policy');
    }
  }
);



// Fetch Policy by ID
export const fetchPolicyById = createAsyncThunk(
  'policies/fetchPolicyById',
  async ({ policyId }: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/policies/${policyId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch policy');
    }
  }
);

// Fetch All Policies
export const fetchAllPolicies = createAsyncThunk(
  'policies/fetchAllPolicies',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/policies');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch policies');
    }
  }
);

export const fetchPolicyByEmployeeId = createAsyncThunk(
  'policies/fetchPolicyByEmployeeId',
  async ({ employeeId, departmentId, branch, gender }: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/policies/employee/emp`, {
        params: {
          employeeId,
          departmentId,
          branch,
          gender
        }
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch policy');
    }
  }
);
export const policy_log = createAsyncThunk(
  'policies/policy_log',
  async ({ policyId , employeeId}: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post(`/policy/${policyId}/${employeeId}/log`);//?policyId=${policyId}&employeeId=${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch policy log');
    }
  }
);
export const fetchPolicyLog = createAsyncThunk(
  'policies/fetchPolicyLog',
  async (policyId: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/policy/logs/${policyId}`);
      console.log("Policy Log Response:", response.data);
      return response.data;
    } catch (error: any) {
      console.error("Error fetching policy log:", error);
      return rejectWithValue(error.response?.data || 'Failed to fetch policy log');
    }
  }
);
